(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/views/pages/result-page.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/views/pages/result-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.vikinglotto=_svs.vikinglotto||{};
_svs.vikinglotto.templates=_svs.vikinglotto.templates||{};
svs.vikinglotto.templates.result_page = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"ngResultRegion\"></div>\n";
},"useData":true});
Handlebars.partials['svs-vikinglotto-result_page'] = svs.vikinglotto.templates.result_page;
})(svs, Handlebars);


 })(window);